import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { CircularProgress, Button, DialogTitle, DialogContent, Dialog, DialogActions } from '@material-ui/core';
import Input from '../Input/Input';
import { auth } from '../../store/actions/auth';
import { setMessage } from '../../store/actions/general';

export const ChangeAccountModal = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const companies = JSON.parse(localStorage.getItem('companies')) || [];
  const currentCompanyCode = JSON.parse(localStorage.getItem('companyCode'));
  const currentCompany =
    companies
      .filter(c => c.companyCode == currentCompanyCode)
      .map(i => ({
        value: i.companyId,
        displayValue: i.companyName,
      }));
  const [selected, setSelected] = useState(currentCompany.length && currentCompany[0].value);

  const handleChange = (event) => {
    setSelected(event.target.value);
  };

  const handleProfileChange = () => {
    setLoading(true);
    const token = localStorage.getItem('token');
    dispatch(auth({ companySelected: selected, token }, true))
      .then(() => {
        window.location.reload();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        handleClose();
        dispatch(setMessage('Ocorreu um erro durante a operação. Tente novamente.'));
      });
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="simple-dialog-title">Escolha uma empresa para continuar</DialogTitle>
      <DialogContent>
        <Input
          elementType="select"
          value={selected}
          onChange={handleChange}
          name="company"
          label="Empresa"
          required
          fullWidth
          margin="normal"
          options={companies.map(item => ({
            value: item.companyId,
            displayValue: item.companyName,
          }))}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={handleClose}>CANCELAR</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleProfileChange}
          disabled={loading}
        >
          {loading
            ? <CircularProgress size={20} color="primary" />
            : 'CONFIRMAR'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
